import svg1_0 from './shapes/points_1_0'
import svg1_1 from './shapes/points_1_1'
import svg2_0 from './shapes/points_2_0'
import svg2_1 from './shapes/points_2_1'
import svg3_0 from './shapes/points_3_0'
import svg3_1 from './shapes/points_3_1'


/**
 * SETTINGS (1, 2, 3)
 */
 export const settings = [
  // ### BANK 01
  {
    soundBank: "01",
    svgs: [svg1_0, svg1_1],
    camera: {},
    object: {
      OBJECT_JUMP_F: 5
    },
    shape: {
      // LINE_COLOR: 0x000000,
    }
  },
  // ### BANK 02
  {
    soundBank: "02",
    svgs: [svg2_0, svg2_1],
    camera: {
      CAMERA_FOCAL_LENGTH: 100,
      CAMERA_FOCUS_F: 10,
      CAMERA_POS_F: 40,
    },
    object: {
      OBJECT_JUMP_F: 2,
      OBJECT_ROTATION_F: .001,
    },
    shape: {
      // LINE_COLOR: 0x000000,
      // SHAPE_MIN_RANGE_X: .2,
      // SHAPE_MIN_RANGE_Y: .2,
      SVG_RANDOM_X: 0,
      SVG_RANDOM_Y: 0,      
    },
  },
  // ### BANK 03
  {
    soundBank: "03",
    svgs: [svg3_0, svg3_1],
    camera: {
      CAMERA_FOCAL_LENGTH: 50,
      CAMERA_FOCUS_F: 110,
    },
    object: {
      OBJECT_JUMP_F: 10,
      OBJECT_ROTATION_F: .01,
      OBJECT_ROTATION_SUFIX: -2.1,
    },
    shape: {
      // LINE_COLOR: 0x000000,
      SHAPE_VECTOR_PASS: "fade",
    },
  },
]


// ### Defaults
const defaults = {
  soundBank: "01",
  svgs: [svg1_0, svg1_1],
  // Camera
  camera: {
    CAMERA_FOCAL_LENGTH: 80,
    CAMERA_POS_F: 10, // arround 20
    CAMERA_FOCUS_F: 40, // arround 20
    CAMERA_POS_SPEED: .06, // arround .06
    CAMERA_FOCUS_SPEED: .06, // arround .06
  },
  // Object
  object: {
    OBJECT_SPACER: 40, // >= 40
    OBJECT_JUMP_F: 4, // arround 4
    OBJECT_MIN_Z: 40, // arround 20
    OBJECT_MAX_Z: 200, // arround 170
    OBJECT_ROTATION_F: .003, // arround .02
    OBJECT_ROTATION_SPEED: .8, // arround .01
    OBJECT_ROTATION_SUFIX: -2.2,
  },
  // Shape
  shape: {
    LINE_COLOR: 0x0083CA,
    LINE_WIDTH_F: .2,
    // ### Sound Interactions
    // Przejście pomiędzy kształtami
    SHAPE_VECTOR_PASS: "cut", // "cut" | "fade"
    // Shape vector modificators
    SHAPE_DIST_RANGE_X: 2.4, // arround 2
    SHAPE_DIST_RANGE_Y: 2.4,
    SHAPE_DIST_RANGE_Z: 0,
    SHAPE_MIN_RANGE_X: 0, // arrouns .4
    SHAPE_MIN_RANGE_Y: 0,
    SHAPE_MIN_RANGE_Z: 0,
    // Shape vector random cutoff
    RANDOM_CUTOFF: 0, // perc
    // vector freq cutoff 
    FREQUENCY_CUTOFF: 120, // 0 - 256
    // shape read randomnes
    SVG_RANDOM_X: 3,
    SVG_RANDOM_Y: 3,
    SVG_RANDOM_Z: 0,
  }
}
let current = defaults

export const setup = (options = {}) => {
  current = {...defaults}
  current.soundBank = options.soundBank ? options.soundBank : current.soundBank
  current.svgs = options.svgs ? options.svgs : current.svgs
  current.camera = options.camera ? ({...current.camera, ...options.camera}) : current.camera
  current.object = options.object ? ({...current.object, ...options.object}) : current.object
  current.shape = options.shape ? ({...current.shape, ...options.shape}) : current.shape
  return current
}

export const getSetup = () => {
  return current
}


